import { useEffect, useRef } from 'react';
const drafts = new Set<symbol>();
export function canLeaveDrafts() {
  return (
    drafts.size === 0 ||
    window.confirm(
      'Kaydedilmemiş değişiklikler var. Değişiklikleri bırakıp ayrılmak istiyor musun?',
    )
  );
}
export function useUnsavedChanges(dirty: boolean) {
  const key = useRef(Symbol('draft'));
  useEffect(() => {
    const id = key.current;
    if (dirty) drafts.add(id);
    const unload = (event: BeforeUnloadEvent) => {
      if (dirty) {
        event.preventDefault();
        event.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', unload);
    return () => {
      drafts.delete(id);
      window.removeEventListener('beforeunload', unload);
    };
  }, [dirty]);
}
